var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    // Shape
    _vm.radius === 20 && 'rounded-2.5xl',
    _vm.radius === 24 && 'rounded-3xl',
    // Colors
    _vm.color === _vm.OzBoxColors.Primary && [
      {
        'bg-white-100': _vm.darkMode === false,
        'bg-nightfall-900': _vm.darkMode === true,
        'bg-white-100 dark:bg-nightfall-900': _vm.darkMode === 'auto',
      },
      {
        'text-dark-text-100': _vm.darkMode === false,
        'text-light-text-100': _vm.darkMode === true,
        'text-dark-text-100 dark:text-light-text-100': _vm.darkMode === 'auto',
      } ],
    _vm.color === _vm.OzBoxColors.Secondary && [
      {
        'bg-light-ui-200': _vm.darkMode === false,
        'bg-dark-ui-200': _vm.darkMode === true,
        'bg-light-ui-200 dark:bg-dark-ui-200': _vm.darkMode === 'auto',
      },
      {
        'text-dark-text-100': _vm.darkMode === false,
        'text-light-text-100': _vm.darkMode === true,
        'text-dark-text-100 dark:text-light-text-100': _vm.darkMode === 'auto',
      } ],
    _vm.color === _vm.OzBoxColors.Selection && [
      {
        'bg-grape-500': _vm.darkMode === false,
        'bg-canary-500': _vm.darkMode === true,
        'bg-grape-500 dark:bg-canary-500': _vm.darkMode === 'auto',
      },
      {
        'text-light-text-100': _vm.darkMode === false,
        'text-dark-text-100': _vm.darkMode === true,
        'text-light-text-100 dark:text-dark-text-100': _vm.darkMode === 'auto',
      } ],
    _vm.color === _vm.OzBoxColors.Highlight && [
      {
        'bg-canary-0': _vm.darkMode === false,
        'bg-dark-ui-200': _vm.darkMode === true,
        'bg-canary-0 dark:bg-dark-ui-200': _vm.darkMode === 'auto',
      },
      {
        'text-light-text-100': _vm.darkMode === true,
        'text-dark-text-100': _vm.darkMode === false,
        'text-dark-text-100 dark:text-light-text-100': _vm.darkMode === 'auto',
      } ],
    _vm.color === _vm.OzBoxColors.Destructive && [
      {
        'bg-tangerine-0': _vm.darkMode === false,
        'bg-dark-ui-200': _vm.darkMode === true,
        'bg-tangerine-0 dark:bg-dark-ui-200': _vm.darkMode === 'auto',
      },
      {
        'text-light-text-100': _vm.darkMode === true,
        'text-dark-text-100': _vm.darkMode === false,
        'text-dark-text-100 dark:text-light-text-100': _vm.darkMode === 'auto',
      } ],
    _vm.color === _vm.OzBoxColors.Pink && [
      {
        'bg-padlet-pink-0': _vm.darkMode === false,
        'bg-dark-ui-200': _vm.darkMode === true,
        'bg-padlet-pink-0 dark:bg-dark-ui-200': _vm.darkMode === 'auto',
      },
      {
        'text-light-text-100': _vm.darkMode === true,
        'text-dark-text-100': _vm.darkMode === false,
        'text-dark-text-100 dark:text-light-text-100': _vm.darkMode === 'auto',
      } ],
    _vm.color === _vm.OzBoxColors.Green && [
      {
        'bg-park-0': _vm.darkMode === false,
        'bg-dark-ui-200': _vm.darkMode === true,
        'bg-park-0 dark:bg-dark-ui-200': _vm.darkMode === 'auto',
      },
      {
        'text-light-text-100': _vm.darkMode === true,
        'text-dark-text-100': _vm.darkMode === false,
        'text-dark-text-100 dark:text-light-text-100': _vm.darkMode === 'auto',
      } ],
    _vm.color === _vm.OzBoxColors.Tangerine && [
      {
        'bg-tangerine-0': _vm.darkMode === false,
        'bg-dark-ui-200': _vm.darkMode === true,
        'bg-tangerine-0 dark:bg-dark-ui-200': _vm.darkMode === 'auto',
      },
      {
        'text-light-text-100': _vm.darkMode === true,
        'text-dark-text-100': _vm.darkMode === false,
        'text-dark-text-100 dark:text-light-text-100': _vm.darkMode === 'auto',
      } ],
    _vm.color === _vm.OzBoxColors.Grape && [
      {
        'bg-grape-0': _vm.darkMode === false,
        'bg-dark-ui-200': _vm.darkMode === true,
        'bg-grape-0 dark:bg-dark-ui-200': _vm.darkMode === 'auto',
      },
      {
        'text-light-text-100': _vm.darkMode === true,
        'text-dark-text-100': _vm.darkMode === false,
        'text-dark-text-100 dark:text-light-text-100': _vm.darkMode === 'auto',
      } ],
    _vm.color === _vm.OzBoxColors.PrimaryBlur && [
      {
        'bg-light-ui-200': _vm.isFirefox && _vm.darkMode === false,
        'bg-dark-ui-200': _vm.isFirefox && _vm.darkMode === true,
        'bg-light-ui-200 dark:bg-dark-ui-200': _vm.isFirefox && _vm.darkMode === 'auto',
        'bg-common-ui-l86': !_vm.isFirefox && _vm.darkMode === false,
        'bg-common-ui-d86': !_vm.isFirefox && _vm.darkMode === true,
        'bg-common-ui-l86 dark:bg-common-ui-d86': !_vm.isFirefox && _vm.darkMode === 'auto',
        'backdrop-filter': true,
        'backdrop-blur-10': true,
      },
      {
        'text-light-text-100': _vm.darkMode === true,
        'text-dark-text-100': _vm.darkMode === false,
        'text-dark-text-100 dark:text-light-text-100': _vm.darkMode === 'auto',
      } ] ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }